import { combineReducers } from 'redux';
import { CLEAR_FORM_FULFILLED } from 'redux/actions';
import { address } from './address';
import { application } from './application';
import { twoFA } from './twoFA';
import { payment } from './payment';
import { cpp } from './cpp';
import PersonalDetails from './personalDetails';
import tattooistDetails from './tattooistDetails';
import applicantDetails from './applicantDetails';
import paymentSuccess from './paymentSuccess';
import employment from './employment';
import documents from './documents';
import { fees } from './fees';
import disclosures from './disclosures';
import collectionOfLicence from './collectionOfLicence';
import FormReducer from './form';
import { reducer as oidcReducer } from 'redux-oidc';
import CaptchaReducer from './captchaValid';
import closeAssociateDetails from './closeAssociatesDetails';
import ownershipDetails from './ownershipDetails';
import premisesDetails from './premisesDetails'
import pdfLink from './pdfLink';
import sendEmailCopy from './sendEmailCopy';
import proofOfResidency from './proofOfResidency';

const appReducer = combineReducers({
  oidc: oidcReducer,
  application,
  payment,
  paymentSuccess,
  cpp,
  captcha: CaptchaReducer,
  form: FormReducer,
  tattooistDetails,
  applicantDetails,
  employment,
  collectionOfLicence,
  disclosures,
  documents,
  twoFA,
  fees,
  pdfLink,
  closeAssociateDetails,
  ownershipDetails,
  premisesDetails,
  sendEmailCopy,
  proofOfResidency
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;
